import { initMixpanelEvents } from "jiffy-analytics";
import { initGallery } from "components/jiffy/made-category/gallery/jiffymade-landing-gallery";
import "components/jiffy/made-category/ui/section-title/section-title";
import deliveryDateFormClass from "common/utils/delivery-date/delivery-date-form-class";
import initMobileMenu from "components/jiffy/mobile-menu/mobile-menu";
import initMastheadCartDropdown from "components/jiffy/masthead-cart-dropdown/masthead-cart-dropdown";
import initResellerPricingModal from "components/jiffy/reseller-pricing-modal/reseller-pricing-modal";
import { sendDataLayerEvent } from "./made-category-print-analytics";
import initMasthead from "./masthead/masthead";
import initHero from "./hero/hero";
import initBenefits from "./benefits/benefits";
import initDeliveryAndQuality from "./delivery-and-quality/delivery-and-quality";
import initBenefitsSwitcher from "./benefits-switcher/benefits-switcher";
import initPrintTechnologyHero from "./print-technology-hero/print-technology-hero";
import initUseCases from "./use-cases/use-cases";
import initReviewTabs from "./review-tabs/review-tabs";
import initJiffymadeLandingFaq from "./faq/jiffymade-landing-faq";

let dataLayerListenerAttached = false;
function initDeclarativeDataLayer() {
  if (dataLayerListenerAttached) return;
  const $container = document.querySelector(".js-made-category-print");
  if (!$container) return;
  dataLayerListenerAttached = true;

  $container.addEventListener("click", e => {
    const $el = e.target.closest("[data-mixpanel-event][data-mixpanel-listen]");
    if (!$el) return;
    const eventName = $el.dataset.mixpanelEvent;
    if (!eventName) return;
    let eventData;
    try {
      eventData = JSON.parse($el.dataset.mixpanelData || "{}");
    } catch {
      eventData = {};
    }
    sendDataLayerEvent(eventName, eventData);
  });
}

const init = () => {
  initMobileMenu();
  initMasthead();
  if (document.querySelector(".js-reseller-pricing-modal")) initResellerPricingModal();
  initMastheadCartDropdown();
  deliveryDateFormClass().init(true);
  initHero();
  initBenefits();
  initDeliveryAndQuality();
  initBenefitsSwitcher();
  initPrintTechnologyHero();
  initUseCases();
  initReviewTabs();
  initGallery();
  initJiffymadeLandingFaq();

  initMixpanelEvents(".js-made-category-print");
  initDeclarativeDataLayer();
};

export default init;
